module.exports = __webpack_public_path__ + "img/wellwellwell1.ff13b7a2.png";